import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { downloadCSVFile } from "utils/csv-utils";
import type { ProductQuantityUploadResult } from "./product-quantity-csv-processor";

export const ProductQuantityErrorAccordion = ({
  uploadResult,
}: {
  uploadResult: ProductQuantityUploadResult;
}) => {
  const lists = buildAccordionInput(uploadResult);

  const handleDownload = (title: string, items: string[]) => {
    const csvContent = ["product_code", ...items].join(",\n");
    downloadCSVFile(csvContent, title);
  };

  return (
    <Box width="100%">
      {lists
        .filter((list) => list.items.length)
        .map((list, idx) => (
          <Accordion key={idx}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Stack
                direction="row"
                justifyContent="space-between"
                flexGrow={1}
              >
                <Typography
                  variant="h6"
                  color={list.error ? "error" : "inherit"}
                >
                  {list.title} ({list.items.length})
                </Typography>
                <IconButton
                  onClick={() => handleDownload(list.title, list.items)}
                  size="small"
                >
                  <FileDownloadIcon />
                </IconButton>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ maxHeight: 400, overflow: "auto" }}>
                <List>
                  {list.items.map((item, index) => (
                    <ListItem key={index} disableGutters dense>
                      <ListItemIcon>
                        <ChevronRightRoundedIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
    </Box>
  );
};

const buildAccordionInput = (uploadResult: ProductQuantityUploadResult) => {
  if (!uploadResult) {
    return [];
  }

  return [
    {
      title: "Successfully Uploaded Product Codes",
      items: uploadResult.success.map((p) => p.value.product.value.code),
    },
    {
      title: "Product Codes Not Found",
      items: uploadResult.nonExistingProductCodes,
      error: true,
    },
    {
      title: "CSV Errors",
      items: uploadResult.errors.map(
        (e) => `${e.value.rowIdentifier}: ${e.value.errors.join(". ")}`,
      ),
      error: true,
    },
  ];
};
